var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10H6.59375L6.8125 11H15.1875C15.6562 11 16.0312 11.4688 15.9062 11.9375L15.75 12.6875C16.3438 12.9688 16.75 13.5625 16.75 14.25C16.75 15.25 15.9375 16.0312 14.9688 16C14.0312 16 13.25 15.25 13.25 14.3125C13.2188 13.8125 13.4375 13.3438 13.75 13H7.21875C7.53125 13.3438 7.75 13.7812 7.75 14.25C7.75 15.25 6.90625 16.0625 5.90625 16C5 15.9688 4.28125 15.25 4.25 14.375C4.1875 13.6562 4.5625 13.0625 5.125 12.75L2.90625 2H0.75C0.3125 2 0 1.6875 0 1.25V0.75C0 0.34375 0.3125 0 0.75 0H3.9375C4.28125 0 4.59375 0.28125 4.6875 0.625L4.96875 2H17.2188C17.7188 2 18.0625 2.46875 17.9688 2.9375L16.5 9.4375C16.4062 9.78125 16.0938 10 15.75 10ZM12.5938 6H11.25V4.125C11.25 3.9375 11.0625 3.75 10.875 3.75H10.125C9.90625 3.75 9.75 3.9375 9.75 4.125V6H8.375C8.0625 6 7.875 6.40625 8.125 6.65625L10.2188 8.75C10.375 8.90625 10.5938 8.90625 10.75 8.75L12.8438 6.65625C13.0938 6.40625 12.9062 6 12.5938 6Z",
    fill: "#232532"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.6e3083c593b2e6284296fb4a40710d79.svg";
export { ForwardRef as ReactComponent };